export const messageToAdminConstants = {
	GetPaged: {
		REQUEST : "GET_MESSAGES_TO_ADMIN_REQUEST",
		SUCCESS : "GET_MESSAGES_TO_ADMIN_SUCCESS",
		FAILURE : "GET_MESSAGES_TO_ADMIN_FAILURE"
	},
	Create: {
		REQUEST : 'CREATE_MESSAGE_TO_ADMIN_REQUEST',
		SUCCESS : 'CREATE_MESSAGE_TO_ADMIN_SUCCESS',
		FAILURE : 'CREATE_MESSAGE_TO_ADMIN_FAILURE'
	},
	Read: {
		REQUEST : 'READ_MESSAGE_TO_ADMIN_REQUEST',
		SUCCESS : 'READ_MESSAGE_TO_ADMIN_SUCCESS',
		FAILURE : 'READ_MESSAGE_TO_ADMIN_FAILURE'
	},
	Spam: {
		REQUEST : 'SPAM_MESSAGE_TO_ADMIN_REQUEST',
		SUCCESS : 'SPAM_MESSAGE_TO_ADMIN_SUCCESS',
		FAILURE : 'SPAM_MESSAGE_TO_ADMIN_FAILURE'
	},
	DownloadFile: {
		REQUEST : 'DOWNLOAD_MESSAGE_TO_ADMIN_FILE_REQUEST',
		SUCCESS : 'DOWNLOAD_MESSAGE_TO_ADMIN_FILE_SUCCESS',
		FAILURE : 'DOWNLOAD_MESSAGE_TO_ADMIN_FILE_FAILURE'
	},
	CLEAR: 'CLEAR_MESSAGE_TO_ADMIN'
}